import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import environment from '@environments/environment';

@Component({
  selector: 'wcg-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss'],
  standalone: false,
})
export class SessionTimeoutDialogComponent implements OnInit, OnDestroy {
  private readonly _dialogRef = inject(
    MatDialogRef<SessionTimeoutDialogComponent>,
  );

  remainingTime: number = environment.sessionGracePeriod / 1000;
  timer: any;
  timeLeft: string = this.formatTime(this.remainingTime);

  ngOnInit() {
    this.startTimer();
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

  startTimer() {
    this.timer = setInterval(() => {
      this.remainingTime--;
      this.timeLeft = this.formatTime(this.remainingTime);

      if (this.remainingTime <= 0) {
        this.logout();
      }
    }, 1000);
  }

  continueSession() {
    this._dialogRef.close(false);
  }

  logout() {
    this._dialogRef.close(true);
  }
}
